const UrlApi = {

  // baseUrl: "http://localhost:3000/admin",
  // baseUrlImage: "http://localhost:3000/uploads/",
  baseUrl: "https://api.house-of-bars.com/admin/",
  baseUrlImage: "https://api.house-of-bars.com/uploads/",

  // auth
  auth: {
    login: "auth/login",
    autologin: "auth/autologin",
    signup: "auth/signup",
    logout: "auth/logout",
    forgotPassword: "auth/forgot-password",
    resetPassword: "auth/reset-password",
  },
  admins: {
    get: "admins/get",
    add: "admins/add",
    edit: "admins/edit",
    delete: "admins/delete",
    getUserType: "admins/get_user_type",
    getUserPrivilegs: "admins/privileg",
    addUserPrivilegs: "admins/addprivileg",
    editUserPrivilegs: "admins/editprivileg",
    deleteprivileg: "admins/deleteprivileg",
  },

  admins_logs: {
    get: "logs/get",
    edit: "logs/edit",
  },


  banners: {
    get: "banners/get",
    edit: "banners/edit",
    add: "banners/add",
    delete: "banners/delete",
  },

  bars: {
    get: "bars/get",
    add: "bars/add",
    edit: "bars/edit",
    delete: "bars/delete",
  },
  bar_images: {
    get: "bar_images/get",
    add: "bar_images/add",
    edit: "bar_images/edit",
    delete: "bar_images/delete",
  },

  clients: {
    get: "clients/get",
    add: "clients/add",
    edit: "clients/edit",
    delete: "clients/delete",
  },

  events: {
    get: "events/get",
    add: "events/add",
    edit: "events/edit",
    delete: "events/delete",
  },
  event_img: {
    get: "event_img/get",
    add: "event_img/add",
    edit: "event_img/edit",
    delete: "event_img/delete",
  },

  founders: {
    get: "founders/get",
    add: "founders/add",
    edit: "founders/edit",
    delete: "founders/delete",
  },
  menu: {
    get: "menu/get",
    add: "menu/add",
    edit: "menu/edit",
    delete: "menu/delete",
  },
  menu_cocktails: {
    get: "menu_cocktails/get",
    add: "menu_cocktails/add",
    edit: "menu_cocktails/edit",
    delete: "menu_cocktails/delete",
  },

  seo: {
    get: 'seo_metadata/get',
    add: 'seo_metadata/add',
    edit: 'seo_metadata/edit',
    delete: 'seo_metadata/delete',
  },

  services: {
    get: "services/get",
    add: "services/add",
    edit: "services/edit",
    delete: "services/delete",
  },
  service_images: {
    get: "service_images/get",
    add: "service_images/add",
    edit: "service_images/edit",
    delete: "service_images/delete",
  },
  stations: {
    get: "stations/get",
    add: "stations/add",
    edit: "stations/edit",
    delete: "stations/delete",
  },
  station_images: {
    get: "station_images/get",
    add: "station_images/add",
    edit: "station_images/edit",
    delete: "station_images/delete",
  },


  settings: {
    get: "settings/get",
    edit: "settings/edit",
  },

  contact: {
    get: "settings/get",
    edit: "settings/edit",
  },

  legalInformation: {
    get: "settings/get",
    edit: "settings/edit",
  },


  intro_call: {
    get: "intro_call/get",
    add: "intro_call/add",
    edit: "intro_call/edit",
    delete: "intro_call/delete",
  },

  quotation: {
    get: "quotation/get",
    delete: "quotation/delete",
  }
};

export default UrlApi;
